const create = (list) => {
    if (Array.isArray(list.skus)) {
        let skus = {};
        list.skus.map(item => {
            item = _getJSON(item);
            for (let key in item) {
                skus[key] = item[key];
            }
        });
        list.skus = skus;
    } else {
        list.skus = _getJSON(list.skus);
    }

    list.products = [];

    return list;
}

const convertQty = (list) => {
    list.products = list.products.map((elem) => {
        const item = elem.items[0];
        elem.quantity = list.migrated ? ( Math.round(list.skus[item.itemId].quantity / item.unitMultiplier) ) :  Math.round(list.skus[item.itemId].quantity);
        return elem;
    });

    return list;
}

const _getJSON = (data) => {
    if (typeof data === 'string') {
        data = JSON.parse(data);
    }

    return data;
}

const ListFactory = {
    create,
    convertQty
}

export default ListFactory;
